<template>
    <div class="createNewUser">
        <div class="infoHolder">
            <i id="closeInfo" class="material-icons" @click="closeAdd">close</i>
            <form class="userInfoForm" autocomplete="off">
                <input id="createUnum" class="userInfoInput" type="text" placeholder="U number">
                <input id="createFname" class="userInfoInput" type="text" placeholder="first name">
                <input id="createLname" class="userInfoInput" type="text" placeholder="last name">
                <input id="createEmail" class="userInfoInput" type="text" placeholder="email">
                stao:
                <select id="createStao">
                    <option v-for="option in staos"
                            :key="option.id"
                            :value="option.id"
                            class="userInfoInput"
                    >
                        {{option.name}}
                    </option>
                </select>
                lagercheff:
                <select id="createLagerCheff">
                    <option value="0">
                        -
                    </option>
                    <option v-for="option in staos"
                            :key="option.id"
                            :value="option.id"
                            class="userInfoInput"
                    >
                        {{option.name}}
                    </option>
                </select>
                <input id="createAutlev" class="userInfoInput" type="text" placeholder="autlev" value="12">
                <!-- <input id="createPw" class="userInfoInput" type="password" placeholder="password">
                <input id="createRpw" class="userInfoInput" type="password" placeholder="repeat password"> -->
                <button class="createButton" @click.prevent="create">create</button>
            </form>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            newUserInfo: {
                unum: '',
                fname: '',
                lname: '',
                telid: '',
                stao: '',
                email: '',
                autlev: '',
                pw: '',
                rpw: '',
                lagerCheff: 0
            }
        }
    },
    computed: {
        staos() {
            return this.$store.getters['user/staos'];
        }
    },
    methods: {
        closeAdd() {
            this.$router.go(-1);
        },
        create() {
            this.newUserInfo.unum = document.getElementById('createUnum').value
            this.newUserInfo.fname = document.getElementById('createFname').value
            this.newUserInfo.lname = document.getElementById('createLname').value
            this.newUserInfo.email = document.getElementById('createEmail').value
            this.newUserInfo.autlev = document.getElementById('createAutlev').value
            this.newUserInfo.stao = document.getElementById('createStao').value;
            this.newUserInfo.lagerCheff = document.getElementById('createLagerCheff').value;

            this.$store.dispatch('user/createNewUser', this.newUserInfo);
        }
    },
    mounted() {
        document.getElementById('createAutlev').title = '1: settings\n2: FDB\n3: edit FDB\n4: del from FDB\n6: Lager Chef\n7: Lagereinfüllen\n8: SRM\n9: SFS\nA: EM';
        this.$store.dispatch('user/getStaos');
    }
}
</script>

<style scoped lang="scss">
    #closeInfo {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        font-size: 2.5rem;
    }

    .createNewUser {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        /*background-color: blue;*/
    }

    .infoHolder {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        /*height: 12.5rem;*/
        background-color: $color-white;
        @include default-shadow;
        padding-top: 0.625rem;
        padding-bottom: 0.625rem;
    }

    .userInfoForm {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 1.25rem;
        margin-right: 2.5rem;
    }

    #createStao {
        height: 3rem;
        font-size: 1.5rem;
    }

    #createLagerCheff {
        height: 3rem;
        font-size: 1.5rem;
    }

    .userInfoInput {
        font-size: 1.25rem;

    }

    .createButton {
        width: 100%;
        color: $color-white;
        font-size: 1.25rem;
        background-color: $color-green;
    }

    @include medium {
        .infoHolder {
            width: 31rem;
        }

    }

    @include extra-large {
        .infoHolder {
            width: 600px;
        }

        .userInfoInput {
            font-size: 2rem;

        }

        .saveButton {
            font-size: 2.5rem;
        }

    }

</style>
